/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const CreateIngressRequestBodyProvider = {
  Tailscale: "tailscale",
} as const;
export type CreateIngressRequestBodyProvider = ClosedEnum<
  typeof CreateIngressRequestBodyProvider
>;

export type CreateIngressRequestBody = {
  /**
   * Lowercase DNS label
   */
  hostname: string;
  identityRequired?: boolean | undefined;
  oauthClientId: string;
  oauthClientSecret: string;
  provider: CreateIngressRequestBodyProvider;
};

/** @internal */
export const CreateIngressRequestBodyProvider$outboundSchema: z.ZodMiniEnum<
  typeof CreateIngressRequestBodyProvider
> = z.enum(CreateIngressRequestBodyProvider);

/** @internal */
export type CreateIngressRequestBody$Outbound = {
  hostname: string;
  identity_required?: boolean | undefined;
  oauth_client_id: string;
  oauth_client_secret: string;
  provider: string;
};

/** @internal */
export const CreateIngressRequestBody$outboundSchema: z.ZodMiniType<
  CreateIngressRequestBody$Outbound,
  CreateIngressRequestBody
> = z.pipe(
  z.object({
    hostname: z.string(),
    identityRequired: z.optional(z.boolean()),
    oauthClientId: z.string(),
    oauthClientSecret: z.string(),
    provider: CreateIngressRequestBodyProvider$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      identityRequired: "identity_required",
      oauthClientId: "oauth_client_id",
      oauthClientSecret: "oauth_client_secret",
    });
  }),
);

export function createIngressRequestBodyToJSON(
  createIngressRequestBody: CreateIngressRequestBody,
): string {
  return JSON.stringify(
    CreateIngressRequestBody$outboundSchema.parse(createIngressRequestBody),
  );
}
